// Mobile menu functionality
function initMobileMenu() {
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle') as HTMLButtonElement;
    const mainNav = document.querySelector('.main-nav') as HTMLElement;

    if (mobileMenuToggle && mainNav) {
        let isAnimating = false;

        // Handle toggle button click
        mobileMenuToggle.addEventListener('click', (e: Event) => {
            e.stopPropagation(); // Prevent event from bubbling up
            if (isAnimating) return;
            isAnimating = true;

            mobileMenuToggle.classList.toggle('active');
            mainNav.classList.toggle('active');

            // Reset animation flag after transition
            setTimeout(() => {
                isAnimating = false;
            }, 300); // Match the transition duration
        });

        // Handle clicks on menu items
        mainNav.addEventListener('click', (e: Event) => {
            const target = e.target as HTMLElement;
            // If clicking a menu item, close the menu
            if (target.tagName.toLowerCase() === 'a') {
                if (isAnimating) return;
                isAnimating = true;

                mobileMenuToggle.classList.remove('active');
                mainNav.classList.remove('active');

                // Reset animation flag after transition
                setTimeout(() => {
                    isAnimating = false;
                }, 300);
            }
            e.stopPropagation(); // Prevent closing when clicking inside menu
        });

        // Close menu when clicking outside
        document.addEventListener('click', (e: MouseEvent) => {
            if (mainNav.classList.contains('active')) {
                const target = e.target as Node;
                if (!mobileMenuToggle.contains(target) && !mainNav.contains(target)) {
                    if (isAnimating) return;
                    isAnimating = true;

                    mobileMenuToggle.classList.remove('active');
                    mainNav.classList.remove('active');

                    // Reset animation flag after transition
                    setTimeout(() => {
                        isAnimating = false;
                    }, 300);
                }
            }
        });

        // Close menu on window resize (in case user switches to desktop view)
        window.addEventListener('resize', () => {
            if (window.innerWidth > 768) {
                mobileMenuToggle.classList.remove('active');
                mainNav.classList.remove('active');
            }
        });
    }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    initMobileMenu();
});